import React, { useEffect, useState } from "react";
import globalStyles from '../../utils/globalStyles';
import { Box, Typography, MenuItem, Select, Button, Grid, TableContainer, Table, TableHead, Paper, TableBody, TableRow, Snackbar, Alert, Switch, TextField, TableCell, CardContent, Card, CardActions,Pagination } from '@mui/material';
import { StyledTableCell, StyledTableRow } from '../../utils/custiomStyle';
import EditIcon from '@mui/icons-material/Edit';
import axios from 'axios';
import legolasApi from '../../api/legolas';
import { styled } from "@mui/material/styles";



const CACHE_KEYS = [
  "products",
  "cart",
  "productPrice",
  "summary",
  "paymentConfig",
  "countryTax",
  "coreConfig",
  "internationalShippingRates",
  "coupon"
];
const LABELS = {
  products: "Products",
  cart: "Cart",
  productPrice: "Product Price",
  summary: "Summary",
  paymentConfig: "Payment Config",
  countryTax: "Country Tax",
  coreConfig: "Core Config",
  internationalShippingRates: "International Shipping Rates",
  coupon: "Coupon"
};
const defaultValue = {
  status: true,
  ttl: "",
  ttlType: "minutes"
};

function CacheConfiguration() {

  const [isEdit, setIsEdit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({ _id: null });
  const [previewData, setPreviewData] = useState(null);
  const [dataList, setDataList] = useState([]);
  const [open, setOpen] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [openError, setOpenError] = useState(false);
  const [error, setError] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [page, setPage] = useState(0);
  const rowsPerPage = 5;
  const [fieldErrors, setFieldErrors] = useState({});
  
  const getInitialFormData = () => {
  const initial = { _id: null };

  CACHE_KEYS.forEach((key) => {
    initial[key] = {
      ...defaultValue,
    };
  });

  return initial;
};

useEffect(() => {
  setFormData(getInitialFormData());
  getListData();
}, []);
 
const handleChange = (key, field, value) => {
  setFormData((prev) => ({
    ...prev,
    [key]: {
      ...(prev[key] || defaultValue),
      [field]:field === "ttl" ? Math.min(Number(value), 2147483647) : value}
  }));

  setFieldErrors((prev) => ({
    ...prev,
    [key]: ""
  }));
};
  
const getListData = async () => {
  try {

    const res = await axios.get(
      `${legolasApi.url}/admin/cache/config/fetch`
    );

    if (res.data?.success && res.data?.data) {

      const { list, active } = res.data.data;

      const dbList = Array.isArray(list)
        ? list
        : [];

      setDataList(dbList);
      setPage(0);

      // =========================
      // ACTIVE CONFIG PREVIEW
      // =========================

      if (active) {

        let parsedPreview = {
          _id: "ACTIVE"
        };

        CACHE_KEYS.forEach((key) => {
          parsedPreview[key] =
            active[key] || { ...defaultValue };
        });

        setPreviewData(parsedPreview);

      } else if (dbList.length > 0) {

        const latest = dbList[0];

        let parsedPreview = {
          _id: latest._id
        };

        CACHE_KEYS.forEach((key) => {

          parsedPreview[key] =
            typeof latest[key] === "string"
              ? JSON.parse(latest[key])
              : latest[key] || { ...defaultValue };

        });

        setPreviewData(parsedPreview);
      }

      // =========================
      // FORM MODE HANDLING
      // =========================

      if (dbList.length > 0) {

        const latest = dbList[0];

        let parsedData = getInitialFormData();

        parsedData._id = latest._id;

        CACHE_KEYS.forEach((key) => {

          const value =
            typeof latest[key] === "string"
              ? JSON.parse(latest[key])
              : latest[key];

          parsedData[key] = {
            ...defaultValue,
            ...value,
          };
        });

        // AUTO FILL FORM
        setFormData(parsedData);

        // SHOW UPDATE CONFIG
        setIsEdit(true);

      } else {

        // NO DATA => CREATE MODE
        setFormData(getInitialFormData());

        // SHOW CREATE CONFIG
        setIsEdit(false);
      }
    }

  } catch (err) {

    console.log("Fetch Error:", err);

  }
};


//   const getListData = async () => {
//   try {
//     const res = await axios.get(`${legolasApi.url}/admin/cache/config/fetch`);

//     if (res.data?.success && res.data?.data) {

//       const { list, active } = res.data.data;

//       const dbList = Array.isArray(list) ? list : [];
//       setDataList(dbList);
//       setPage(0);

//       if (active) {
//         let parsedPreview = { _id: "ACTIVE" };

//         CACHE_KEYS.forEach((key) => {
//           parsedPreview[key] = active[key] || { ...defaultValue };
//         });

//         setPreviewData(parsedPreview);
//       }
//       else if (dbList.length > 0) {
//         const latest = dbList[0];

//         let parsedPreview = { _id: latest._id };

//         CACHE_KEYS.forEach((key) => {
//           parsedPreview[key] =
//             typeof latest[key] === "string"
//               ? JSON.parse(latest[key])
//               : latest[key] || { ...defaultValue };
//         });

//         setPreviewData(parsedPreview);
//       }
//     }
//   } catch (err) {
//     console.log("Fetch Error:", err);
//   }
// };

const isFormValid = () => {
  return CACHE_KEYS.every((key) => {
    const item = formData[key];
    if (item?.status) {
      return item.ttl && Number(item.ttl) > 0;
    }
    return true;
  });
};
const validateForm = () => {
  let errors = {};

  CACHE_KEYS.forEach((key) => {
    const item = formData[key];
    const ttl = Number(item.ttl);

    if (item?.status) {
    if ( !ttl || ttl <= 0 || ttl > 2147483647)
          //errors[key] = "TTL must be > 0";
        errors[key] = "TTL must be between 1 and 2147483647";
    }
  });

  setFieldErrors(errors);

  return Object.keys(errors).length === 0;
};

const handleSubmit = async () => {

  const isValid = validateForm();

  if (!isValid) {
    handleErrorMsg("Please fix validation errors");
    return;
  }

  setLoading(true);

  try {
    let payload = {};

    if (isEdit && formData._id) {
      payload._id = formData._id;
    }

    CACHE_KEYS.forEach((key) => {
      payload[key] = {
        status: formData[key]?.status || false,
        ttl: formData[key]?.status ? Number(formData[key]?.ttl) : 0,
        ttlType: formData[key]?.ttlType || "minutes",
      };
    });

    if (isEdit) {
      await axios.put(`${legolasApi.url}/admin/cache/config/update`, payload);
      handleEditSuccessMsg();
    } else {
      await axios.post(`${legolasApi.url}/admin/cache/config/save`, payload);
      handleSuccessMsg();
    }

    // setFormData(getInitialFormData());
    // setIsEdit(false);
    await getListData();

    setFieldErrors({}); // reset errors
    //getListData();

  } catch (err) {
    console.log(err);
    handleErrorMsg("Error saving cache configuration");
  }

  setLoading(false);
};

  const handleEditClick = (data) => {
  let parsedData = getInitialFormData();

  parsedData._id = data._id;

  CACHE_KEYS.forEach((key) => {
    const value =
      typeof data[key] === "string"
        ? JSON.parse(data[key])
        : data[key];

    parsedData[key] = {
      ...defaultValue,
      ...value,
    };
  });

  setFormData(parsedData);
  setIsEdit(true);

  window.scrollTo({ top: 0, behavior: "smooth" });
};
  const close = () => {
    setOpen(false);
    setOpenEdit(false);
    setOpenError(false);
  };

  const handleSuccessMsg = () => {
    setOpen(true);
    setTimeout(() => setOpen(false), 3000);
  };

  const handleEditSuccessMsg = () => {
    setOpenEdit(true);
    setTimeout(() => setOpenEdit(false), 3000);
  };

  const handleErrorMsg = (message) => {
    setError(message);
    setOpenError(true);
    setTimeout(() => {
      setError('');
      setOpenError(false);
    }, 3000);
  };

const handlePagination = (event, value) => {
  setCurrentPage(value);
};
  return (
    <Box sx={{ margin: "20px 30px" }}>
      <Typography variant="h5" sx={{ mb: 2 }}>
        Cache Control Configuration
      </Typography>
     
{/* CREATE SUCCESS */}
<Snackbar
  open={open}
  autoHideDuration={3000}
  onClose={close}
  anchorOrigin={{
    vertical: "top",
    horizontal: "center"
  }}
>
  <Alert
    severity="success"
    sx={{
      width: 400,
      mt: "80px"
    }}
  >
    Cache configuration has been added successfully
  </Alert>
</Snackbar>

{/* UPDATE SUCCESS */}
<Snackbar
  open={openEdit}
  autoHideDuration={3000}
  onClose={close}
  anchorOrigin={{
    vertical: "top",
    horizontal: "center"
  }}
>
  <Alert
    severity="success"
    sx={{
      width: 400,
      mt: "80px"
    }}
  >
    Cache configuration has been updated successfully
  </Alert>
</Snackbar>
      <Grid container spacing={2} sx={{ mt: 3, maxWidth: 1350, mx: "auto", justifyContent: "center", alignItems: "flex-start" }}>
        <Grid item xs={8} md={5} lg={5.5}>
          <Card elevation={2} sx={{ borderRadius: 2, }}>
            <CardContent sx={{ p: 2 }}>
              <Typography variant="h6" sx={{ mb: 2, fontWeight: 600, color: "#2b3f7a" }}> {isEdit ? "Edit Configuration" : "Create Configuration"}</Typography>

              {formData._id && (
          <TextField fullWidth size="small" label="ID" value={formData._id} sx={{ mb: 2 }} InputProps={{ readOnly: true }}/>)}
              <Grid container spacing={1}>
                {CACHE_KEYS.map((key) => (
                  <Grid item xs={12} key={key}>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "flex-start", // important
                        gap: 1,
                        border: "1px solid #e5e7eb",
                        borderRadius: 2,
                        px: 1.5,
                        py: 1
                      }}
                    >
                      <Typography sx={{ width: "22%", fontWeight: 500, fontSize: "14px" }}>
                        {LABELS[key] || key}
                      </Typography>

                      <Switch
                        size="small"
                        checked={formData[key]?.status || false}
                        onChange={(e) => handleChange(key, "status", e.target.checked)}
                      />

                      <TextField
                        size="small"
                        type="number"
                        disabled={!formData[key]?.status}
                        label="TTL"
                        sx={{ width: "28%" }}
                        value={formData[key]?.ttl || ""}
                        onChange={(e) => handleChange(key, "ttl", e.target.value)}
                        error={!!fieldErrors[key]}
                        helperText={fieldErrors[key] || ""}
                      />

                      <TextField
                        select
                        size="small"
                        label="TTL Type"
                        sx={{ width: "32%" }}
                        value={formData[key]?.ttlType || "minutes"}
                        onChange={(e) => handleChange(key, "ttlType", e.target.value)}
                      >
                        <MenuItem value="minutes">Minutes</MenuItem>
                        <MenuItem value="hours">Hours</MenuItem>
                        <MenuItem value="days">Days</MenuItem>
                      </TextField>
                    </Box>
                  </Grid>
                ))}
              </Grid>
            </CardContent>
            <CardActions sx={{ justifyContent: "flex-end", px: 2, pb: 2 }}>
              <Button size="small" variant="contained" sx={{ backgroundColor: "#2b3f7a", borderRadius: 2, px: 3 }}
                onClick={handleSubmit} disabled={loading}>
                {isEdit ? "Update Config" : "Create Config"}
              </Button>
            </CardActions>
          </Card>
        </Grid>

        <Grid item xs={12} md={4} lg={3.5}>
          {previewData && (
            <Card elevation={2} sx={{ borderRadius: 2, backgroundColor: "#fafbff" }}>
              <CardContent sx={{ p: 2 }}>
                <Typography variant="h6" sx={{ mb: 2, fontWeight: 600, color: "#2b3f7a" }}> Active Configuration</Typography>
                <Grid container spacing={1}>
                  {CACHE_KEYS.map((key) => (
                    <Grid item xs={12} key={key}>
                      <Box sx={{
                        display: "flex", alignItems: "center", justifyContent: "space-between", border: "1px solid #e5e7eb", borderRadius: 2,
                        px: 1.5, py: 1, backgroundColor: "#fff"
                      }}>
                        <Box>
                          <Typography sx={{ fontWeight: 500, fontSize: "14px", color: "#2b3f7a" }} > {LABELS[key] || key} </Typography>
                          <Typography sx={{ fontSize: "12px", color: "#666", mt: 0.3 }}> TTL : {previewData[key]?.ttl || 0} </Typography>
                        </Box>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                          <Typography sx={{ fontSize: "12px", fontWeight: 500, color: previewData[key]?.status ? "green" : "red" }}>
                            {previewData[key]?.status ? "Active" : "Inactive"}
                          </Typography>
                          <Switch size="small" checked={previewData[key]?.status || false} disabled />
                        </Box>
                      </Box>
                    </Grid>
                  ))}
                </Grid>
              </CardContent>
            </Card>
          )}
        </Grid>
      </Grid>
      <TableContainer component={Paper} sx={{ marginTop: '40px', marginBottom: '40px' }} >
        <Table>
          <TableHead sx={{ backgroundColor: globalStyles.colors.backgroundPrimary }}>
            <TableRow>
              <StyledTableCell align='center'> ID </StyledTableCell>
              {CACHE_KEYS.map((key) => (
                <StyledTableCell align='center' key={key}>
                  {LABELS[key] || key}
                </StyledTableCell>
              ))}
              <StyledTableCell align='center'> Action </StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
           {dataList.slice((currentPage - 1) * rowsPerPage,currentPage * rowsPerPage).map((data) => (              
                <StyledTableRow key={data._id}>
                <StyledTableCell align="center"> {data._id} </StyledTableCell>
                {CACHE_KEYS.map((key) => {
                  let value = typeof data[key] === "string" ? JSON.parse(data[key]) : data[key];
                  return (
                    <StyledTableCell align="center" key={key}> {value?.status ? "Yes" : "No"}
                      <br /> {value?.ttl} {value?.ttlType}
                    </StyledTableCell>
                  );
                })}
                <StyledTableCell align='center'>
                  <EditIcon sx={{ cursor: 'pointer', color: '#2b3f7a' }} onClick={() => handleEditClick(data)} />
                </StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Box sx={{ display: "flex",justifyContent: "center",mt: 2}}>
     <Pagination count={Math.ceil(dataList.length / rowsPerPage) } page={currentPage} onChange={handlePagination} color="primary"/>
      </Box>
    </Box>
  );
}
export default CacheConfiguration;
